import PropTypes from 'prop-types';
import React from 'react';

import {thirdPartyTunnelsColumns} from '@modules/client/views/ThirdPartyTunnelsColumns';
import Table from '@appComponents/Table';
import {thirdPartyTunnelsRowRenderer} from '@modules/client/views/ThirdPartyTunnelsRowRenderer';

const ThirdPartyTunnelsTable = (props) => {
    const {clientId, loading, thirdPartyClientTunnelsStorages, vtdTunnels} = props;

    return (
        <div className='third_party_tunnels__table'>
            <Table
                name='thirdPartyClientTunnelsList'
                noDataText='No Tunnels found'
                columns={thirdPartyTunnelsColumns}
                data={thirdPartyClientTunnelsStorages}
                loading={loading}
                rowRenderer={thirdPartyTunnelsRowRenderer}
                rowRendererProps={{
                    clientId: clientId,
                    vtdTunnels: vtdTunnels,
                }}
                pagination={false}
            />
        </div>
    );
};

ThirdPartyTunnelsTable.propTypes = {
    clientId: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    thirdPartyClientTunnelsStorages: PropTypes.array,
    vtdTunnels: PropTypes.array,
};

ThirdPartyTunnelsTable.defaultProps = {
    thirdPartyClientTunnelsStorages: [],
};

export default ThirdPartyTunnelsTable;
